<template>
    <div
        class="img_course"
        :style="{
            'background-image':
            'url(' +
            require(`@/assets/images/flags/${imageSource}.svg`) +
            ')'
        }"
    ></div>
</template>
<script>
export default {
    name: 'LanguageFlag',
    data() {
        return {
            
        }
    },
    props: ['imageSource']
}
</script>